'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$Batch() {
  this.j7 = null;
  this.q8 = null;
  this.j7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.a4.a5($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().aD());
  this.q8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.a4.a5(false);
}
export { $c_Lpresto_TwoFactorAuthView$Batch as $c_Lpresto_TwoFactorAuthView$Batch };
$p = $c_Lpresto_TwoFactorAuthView$Batch.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$Batch;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$Batch() {
}
export { $h_Lpresto_TwoFactorAuthView$Batch as $h_Lpresto_TwoFactorAuthView$Batch };
$h_Lpresto_TwoFactorAuthView$Batch.prototype = $p;
var $d_Lpresto_TwoFactorAuthView$Batch = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$Batch, "presto.TwoFactorAuthView$Batch", ({
  TF: 1
}));
export { $d_Lpresto_TwoFactorAuthView$Batch as $d_Lpresto_TwoFactorAuthView$Batch };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$-Batch.js.map
